import React, { useEffect } from "react"
import { Status, Empty } from "@bitcine/cs-theme"
import { withRouter } from "react-router-dom"
import { useDispatch } from "react-redux"
import { externalLogin } from "@api/account"


const AuthCallback = ({ location }) => {
  const dispatch = useDispatch()
  const params = new URLSearchParams(location.search)
  const errorParam = params.get("error")
  const errorDescription = params.get("error_description")

  useEffect(() => {
    // Only proceed with login flow if there's no error
    if (!errorParam) {
      const code = params.get("code")
      const stateData = params.get("state")
      dispatch(externalLogin(code, stateData))
    }
  }, [])

  // Display error if OAuth provider returned one
  if (errorParam) {
    const errorMessage = errorDescription
      ? decodeURIComponent(errorDescription.replace(/\+/g, ' '))
      : errorParam

    return (
      <div className='text-center col-12'>
        <Empty
          icon='error'
          title='Authentication Error'
          text={errorMessage}
        />
      </div>
    )
  }

  return (
    <Status pending={true} />
  )
}

export default withRouter(AuthCallback)
